import React, { useState } from 'react'
import './FreeCourseItem.css'
import { Row, Col } from 'react-bootstrap'
import { axiosConfig } from '../../Configuration/axios/axiosConfiguration';

export default function FreeCourseItem({ item }) {
    const [acticeTransition, setActiveTransition] = useState(false)
    return (
        <div className='free-course-item' onMouseEnter={() => setActiveTransition(true)} onMouseLeave={() => setActiveTransition(false)}>
            <div className={`free-course-image ${acticeTransition ? 'active' : ''}`}>
                <img src={axiosConfig.defaults.baseURL + "Images/CourseImage/" + item.id + "/" + item.imagePath} alt={item.title} />
            </div>
            <div className='free-course-info'>
                <div className='free-course-item-title'>
                    <h3>{item.title}</h3>
                </div>
                <div className='free-course-price'>
                    <Row>
                        <Col>
                            <div className='current-price' style={{color:"white"}}>
                                رایگان
                            </div>
                        </Col>
                    </Row>
            </div>
            </div>
        </div>
    )
}
